import { render, staticRenderFns } from "./CardHorizontal.vue?vue&type=template&id=bb631b3c&scoped=true&name=card-horizontal&"
import script from "./CardHorizontal.vue?vue&type=script&lang=js&"
export * from "./CardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./CardHorizontal.vue?vue&type=style&index=0&id=bb631b3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb631b3c",
  null
  
)

export default component.exports